export function author(state: object = {}, action: any) {
    switch (action.type) {
        case 'GET_AUTHOR_SUCCESS':
            return {...state, entities: action.data}
        case 'GET_AUTHOR_ERROR':
            return {...state, error: action.data}
        case 'LOADING_AUTHOR':
            return {...state, fetching: action.data}
        default :
            return state
    }
}

export function authorReports(state: object = {}, action: any) {
    switch (action.type) {
        case 'GET_AUTHOR_REPORTS_SUCCESS':
            return {...state, entities: action.data}
        case 'GET_AUTHOR_REPORTS_ERROR':
            return {...state, error: action.data}
        case 'GETTING_AUTHOR_REPORTS':
            return {...state, fetching: action.data}
        default :
            return state
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/scenes/Search/reducers.tsx